import { useEffect, useState } from 'react';
import { isAuthenticatedJWT, subscribeAuthChanges } from '../utils/auth';

/**
 * Hook réactif autour de `isAuthenticatedJWT()`.
 *
 * Pourquoi c'est nécessaire :
 * `isAuthenticatedJWT()` est synchrone (sessionStorage / cookie). Or, en mode
 * iframe, l'auth se termine en asynchrone via `useIframeAuthBoot` qui appelle
 * `setJWT()` après le premier render. Sans ce hook, les composants qui ont
 * lu `isAuthenticatedJWT()` pendant ce premier render ne se re-renderaient
 * jamais → écran vide jusqu'à un évènement (changement d'onglet, navigation)
 * provoquant un nouveau render.
 *
 * Le hook s'abonne à l'évènement custom dispatché par `setJWT`/`clearJWT`
 * (et au `storage` event pour les changements depuis un autre onglet).
 */
export function useIsAuthenticated(): boolean {
  const [isAuth, setIsAuth] = useState<boolean>(() => isAuthenticatedJWT());

  useEffect(() => {
    const refresh = () => setIsAuth(isAuthenticatedJWT());
    refresh();
    return subscribeAuthChanges(refresh);
  }, []);

  return isAuth;
}

export default useIsAuthenticated;
